import style from './style.scss';

/**
 * The Table component provides a wrapper table element
 * that applies consistent styling. Rows are provided as children
 * (within thead and tbody sections).
 */
const Table = props => (
	<table class={style.table}>
		{ props.children }
	</table>
);

export default Table;



// WEBPACK FOOTER //
// ./components/table/index.js